import * as React from "react"

interface ButtonProps extends React.ButtonHTMLAttributes<HTMLButtonElement> {
  variant?: "default" | "outline"
  size?: "default" | "lg"
}

const Button = React.forwardRef<HTMLButtonElement, ButtonProps>(
  ({ className, variant = "default", size = "default", ...props }, ref) => {
    const baseClass = "button"
    const variantClass = variant === "outline" ? "button-outline" : "button-default"
    const sizeClass = size === "lg" ? "button-lg" : ""

    return <button ref={ref} className={`${baseClass} ${variantClass} ${sizeClass} ${className || ""}`} {...props} />
  },
)
Button.displayName = "Button"

export { Button }
